import { JSX, useState } from 'react';
import CrudPage from '@modules/cruds/CrudPage';

import KPIExecutions from './KpiExecutions';
import KPIsForm from './KPIsForm';
import momentTZ from 'moment-timezone';
import * as yup from 'yup';
import { Tabs } from '@ts/storybook';
import { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';
import { useRouterContext } from '@utils/context/RouterContext';

const kpiDefinitionSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  kpiOperation: yup
    .mixed()
    .test('is-string-or-object', 'KpiOperation', value => {
      return typeof value === 'string' || typeof value === 'object';
    })
    .required()
    .label('KPI Operation'),
  ruleset: yup
    .mixed()
    .test('is-string-or-object', 'RuleSet', value => {
      return typeof value === 'string' || typeof value === 'object';
    })
    .required()
    .label('Ruleset'),
});

const KPIsPage = props => {
  const { transferPropsRoute } = useRouterContext();

  const [activeTab, setActiveTab] = useState('definition');
  const tabs = [
    { label: 'Definition', value: 'definition' },
    { label: 'Executions', value: 'executions' },
  ];

  //#region Render
  const renderKPIexec = () => {
    return <KPIExecutions {...props} fnChange={props.fnChange} kpiDefinitionId={transferPropsRoute.params.id} />;
  };

  const renderCrudPage = () => {
    return (
      <CrudPage
        key={'kpiPage'}
        configComponent={generateConfigComponent('kpi')}
        form={KPIsForm}
        validationSchema={kpiDefinitionSchema}
        defaultValues={{
          statisticsToCalculate: [],
          resultOptions: [],
          scheduleConfig: {
            enabled: true,
            schedule: '0 * * * *',
            dataPeriod: {
              type: 'relative',
              params: {
                start: '0 * * * *',
                end: '0 * * * *',
              },
            },
            timezone: momentTZ.tz.guess(),
          },
        }}
      />
    );
  };

  const renderContents = () => {
    let contents: JSX.Element | null = null;

    switch (activeTab) {
      case 'definition':
        contents = renderCrudPage();
        break;
      case 'executions':
        contents = renderKPIexec();
        break;
    }

    return contents;
  };
  //#endregion

  return (
    <Tabs id={'kpi-page'} tabs={tabs} value={activeTab} onChange={(e, v) => setActiveTab(v)}>
      {renderContents()}
    </Tabs>
  );
};

export default KPIsPage;
